(() => {
  if (!customElements.get('xuk-home-aftercare')) {
    customElements.define('xuk-home-aftercare', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const r = this.querySelector('#xuk-support');
        const mobile = matchMedia('(max-width:600px)');
        const reduce = matchMedia('(prefers-reduced-motion:reduce)');
        const buttons = [...r.querySelectorAll('.os-toggle')];
        const nodes = [...r.querySelectorAll('.os-journey li')];
        const pause = r.querySelector('.os-pause');
        const opened = new Set(buttons.flatMap((b, i) => b.closest('.os-card').dataset.defaultOpen === 'true' ? [i] : []));
        const draw = () => buttons.forEach((b, i) => {
          const open = !mobile.matches || opened.has(i);
          const panel = b.closest('.os-card').querySelector('.os-body');
          panel.hidden = false;
          panel.inert = !open;
          b.setAttribute('aria-expanded', String(open));
          b.querySelector('.os-sign').textContent = open ? '\u2212' : '+';
          b.tabIndex = mobile.matches ? 0 : -1;
          panel.style.height = mobile.matches ? (open ? panel.scrollHeight + 'px' : '0px') : 'auto';
          panel.style.opacity = open ? '1' : '0';
          panel.setAttribute('aria-hidden', String(!open));
        });
        buttons.forEach((b, i) => b.addEventListener('click', () => {
          if (!mobile.matches) return;
          opened.has(i) ? opened.delete(i) : opened.add(i);
          draw();
        }, { signal }));
        mobile.addEventListener('change', draw, { signal });
        window.addEventListener('resize', draw, { signal });
        draw();
        let elapsed = 0, last = 0, visible = false;
        let paused = r.dataset.autoplay !== 'true';
        const duration = Number(r.dataset.duration) || 3200;
        const count = nodes.length;
        const paint = () => {
          const index = count ? Math.floor(elapsed / duration) % count : 0;
          nodes.forEach((n, i) => n.classList.toggle('is-active', i === index));
          r.style.setProperty('--os-progress', String(count > 1 ? Math.min(elapsed / (duration * (count - 1)), 1) : 0));
          r.dataset.osStage = index;
        };
        const allowed = () => visible && !document.hidden && !paused && !reduce.matches && count > 1;
        const tick = t => {
          if (!allowed()) return;
          if (last) elapsed = (elapsed + t - last) % (duration * count);
          last = t;
          paint();
          this.raf = requestAnimationFrame(tick);
        };
        const sync = () => {
          cancelAnimationFrame(this.raf);
          last = 0;
          pause.disabled = reduce.matches;
          pause.textContent = reduce.matches ? r.dataset.staticLabel : paused ? '\u25b6 ' + r.dataset.resumeLabel : '\u2161 ' + r.dataset.pauseLabel;
          pause.setAttribute('aria-pressed', String(paused));
          if (allowed()) this.raf = requestAnimationFrame(tick);
        };
        pause.addEventListener('click', () => { paused = !paused; sync(); }, { signal });
        this.observer = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting;
          if (visible) r.classList.add('os-entered');
          sync();
        }, { threshold: 0 });
        this.observer.observe(r);
        document.addEventListener('visibilitychange', sync, { signal });
        reduce.addEventListener('change', () => {
          if (reduce.matches) { elapsed = 0; paint(); }
          sync();
        }, { signal });
        paint();
        sync();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.raf);
      }
    });
  }
  if (!customElements.get('xuk-home-faq')) {
    customElements.define('xuk-home-faq', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const root = this.querySelector('#faq');
        const tabs = [...root.querySelectorAll('.tab')];
        const panels = [...root.querySelectorAll('.panel')];
        const items = [...root.querySelectorAll('.item')];
        const count = root.querySelector('.question-count');
        const suffix = count.textContent.replace(/^\d+\s*/, '');
        const switchAudience = (audience, focus = false) => {
          root.querySelector('.tabs').dataset.audience = audience;
          tabs.forEach(tab => {
            const selected = tab.dataset.audience === audience;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
            if (selected && focus) tab.focus();
          });
          panels.forEach(panel => {
            panel.hidden = panel.dataset.audience !== audience;
            panel.classList.remove('is-entering');
            if (!panel.hidden) {
              void panel.offsetWidth;
              panel.classList.add('is-entering');
              count.textContent = panel.querySelectorAll('.item').length + ' ' + suffix;
            }
          });
        };
        tabs.forEach(tab => {
          tab.addEventListener('click', () => switchAudience(tab.dataset.audience), { signal });
          tab.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            switchAudience(event.key === 'Home' ? 'home' : event.key === 'End' ? 'business' : tab.dataset.audience === 'home' ? 'business' : 'home', true);
          }, { signal });
        });
        const setOpen = (item, open) => {
          item.dataset.open = String(open);
          item.querySelector('.question').setAttribute('aria-expanded', String(open));
          const answer = item.querySelector('.answer');
          answer.inert = !open;
          answer.setAttribute('aria-hidden', String(!open));
        };
        items.forEach(item => {
          setOpen(item, item.dataset.open === 'true');
          item.querySelector('.question').addEventListener('click', () => {
            const open = item.dataset.open !== 'true';
            item.closest('.panel').querySelectorAll('.item').forEach(sibling => setOpen(sibling, sibling === item && open));
          }, { signal });
        });
        switchAudience(root.dataset.defaultAudience || 'home');
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
      }
    });
  }
})();
